import { Alert } from '@mui/material';
import AppConfirmDialog from '@crema/components/AppConfirmDialog';

type ConfirmModalProps = {
  setOpen?: boolean;
  onAuth?: () => void;
  onClose?: () => void;
};

const ConfirmModal = ({ setOpen = false, onClose, onAuth }: ConfirmModalProps) => (
  <AppConfirmDialog
    open={setOpen}
    dialogTitle="Cafe24 인증을 진행하시겠습니까?"
    title={
      <Alert severity="info">
        ※ Cafe24 인증을 진행하지 않아도 사용은 가능하나 cafe24 계정 내 어플리케이션 설치가 완료되지 않습니다.
        <br />
        또한, Cafe24 인증을 진행하지 않은 상태에서 페이지를 새로고침하면 Cafe24 인증페이지로 강제 이동됩니다.
        <br /> (인증 없이 설정한 데이터는 계속 유지됩니다.)
      </Alert>
    }
    confirmTitle="진행"
    denyTitle="취소"
    onConfirm={() => onAuth?.()}
    onDeny={() => onClose?.()}
  />
);

export default ConfirmModal;
